export default "__VITE_ASSET__fc810a2b__"